import { Auth } from "aws-amplify";

export const getUser = () => {
  return Auth.currentAuthenticatedUser();
};
